export const createNumberArray = (from: number, to: number): number[] => {
  return [...Array(to + 1).keys()].filter((num) => num >= from);
};

export const parseStringToNumber = (value?: string | null): number | undefined => {
  if (value === undefined || value === null) return undefined;

  // Remove commas from the string (e.g., "1,234,567.89" -> "1234567.89")
  const sanitizedValue = value.replace(/,/g, '');

  const parsedValue = parseFloat(sanitizedValue);

  return Number.isNaN(parsedValue) ? undefined : parsedValue;
};
